import type { IconProps } from '../../../components/Icon/Icon.util';

export const Menu = ({
  title,
  width = 32,
  height = 32,
  fill = 'none',
  role = 'presentation',
}: IconProps): React.ReactNode => {
  const viewBoxSize = 32;

  return (
    <svg
      fill={fill}
      focusable='false'
      height={height}
      role={role}
      viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
      width={width}
      xmlns='http://www.w3.org/2000/svg'
    >
      {title ? <title>{title}</title> : null}

      <path d='M1 6C1 5.44772 1.44772 5 2 5H30C30.5523 5 31 5.44772 31 6C31 6.55228 30.5523 7 30 7H2C1.44772 7 1 6.55228 1 6Z' />
      <path d='M1 16C1 15.4477 1.44772 15 2 15H30C30.5523 15 31 15.4477 31 16C31 16.5523 30.5523 17 30 17H2C1.44772 17 1 16.5523 1 16Z' />
      <path d='M1 26C1 25.4477 1.44772 25 2 25H30C30.5523 25 31 25.4477 31 26C31 26.5523 30.5523 27 30 27H2C1.44772 27 1 26.5523 1 26Z' />
    </svg>
  );
};
